import type { CargoProblemListQuery } from '@magimp/shared';

export interface CargoProblemsFiltersState {
  q: string;
  status: string;
  category: string;
  queue: string;
  authorId: string;
  assigneeId: string;
  carrier: string;
  createdFrom: string;
  createdTo: string;
  updatedFrom: string;
  updatedTo: string;
  overdueOnly: boolean;
}

export const EMPTY_CARGO_PROBLEM_FILTERS: CargoProblemsFiltersState = {
  q: '',
  status: '',
  category: '',
  queue: '',
  authorId: '',
  assigneeId: '',
  carrier: '',
  createdFrom: '',
  createdTo: '',
  updatedFrom: '',
  updatedTo: '',
  overdueOnly: false,
};

function startOfLocalDay(value: string): string | undefined {
  return value ? new Date(`${value}T00:00:00`).toISOString() : undefined;
}
function endOfLocalDay(value: string): string | undefined {
  return value ? new Date(`${value}T23:59:59.999`).toISOString() : undefined;
}

export function cargoProblemQuery(filters: CargoProblemsFiltersState): CargoProblemListQuery {
  const q = filters.q.trim();
  return {
    ...(q.length >= 2 ? { q } : {}),
    ...(filters.status ? { status: filters.status as CargoProblemListQuery['status'] } : {}),
    ...(filters.category
      ? { category: filters.category as CargoProblemListQuery['category'] }
      : {}),
    ...(filters.queue ? { queue: filters.queue as CargoProblemListQuery['queue'] } : {}),
    ...(filters.authorId ? { authorId: filters.authorId } : {}),
    ...(filters.assigneeId ? { assigneeId: filters.assigneeId } : {}),
    ...(filters.carrier ? { carrier: filters.carrier } : {}),
    ...(startOfLocalDay(filters.createdFrom)
      ? { createdFrom: startOfLocalDay(filters.createdFrom) }
      : {}),
    ...(endOfLocalDay(filters.createdTo) ? { createdTo: endOfLocalDay(filters.createdTo) } : {}),
    ...(startOfLocalDay(filters.updatedFrom)
      ? { updatedFrom: startOfLocalDay(filters.updatedFrom) }
      : {}),
    ...(endOfLocalDay(filters.updatedTo) ? { updatedTo: endOfLocalDay(filters.updatedTo) } : {}),
    ...(filters.overdueOnly ? { overdueOnly: true } : {}),
  };
}

export function activeCargoProblemFilterCount(filters: CargoProblemsFiltersState): number {
  return Object.entries(filters).filter(([, value]) => value !== '' && value !== false).length;
}
